import React, { useState, useEffect, useCallback, useRef } from "react";
import "../css/Slideshow.css"; // Optional: Add styles for the slideshow

const Slideshow = ({ images, category, loading }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [preloadedImages, setPreloadedImages] = useState({});
  const [preloadingComplete, setPreloadingComplete] = useState(false);
  const loadedCountRef = useRef(0);

  // Preload all images when the images array changes
  useEffect(() => {
    if (!images || images.length === 0) {
      setPreloadedImages({});
      setPreloadingComplete(false);
      return;
    }

    setPreloadingComplete(false);
    loadedCountRef.current = 0;
    const totalImages = images.length;
    const imageStatusMap = {};

    const handleImageLoad = (index, success) => {
      imageStatusMap[index] = { loaded: true, error: !success };
      loadedCountRef.current += 1;
      if (loadedCountRef.current === totalImages) {
        setPreloadedImages({ ...imageStatusMap });
        setPreloadingComplete(true);
      }
    };

    images.forEach((src, index) => {
      const img = new Image();
      img.onload = () => handleImageLoad(index, true);
      img.onerror = () => handleImageLoad(index, false);
      img.src = src;
    });

    // Cleanup on unmount or when images change
    return () => {
      loadedCountRef.current = 0;
      setPreloadedImages({});
    };
  }, [images]);

  // Reset index when images change
  useEffect(() => {
    setCurrentIndex(0);
  }, [images]);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Scorrimento automatico ogni 3 secondi
  useEffect(() => {
    if (images.length === 0 || !preloadingComplete) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length, preloadingComplete]);

  // Show loading placeholder if loading, no images, or preloading in progress
  if (loading || images.length === 0 || !preloadingComplete) {
    return (
      <div className={`slideshow slideshow-loading ${category ? `slideshow-${category}` : ""}`}>
        <div className="slideshow-placeholder">
          <div className="loading-spinner"></div>
          <p className="loading-text">Caricamento immagini...</p>
        </div>
      </div>
    );
  }

  const currentImageStatus = preloadedImages[currentIndex] || { loaded: false, error: false };

  return (
    <div className={`slideshow ${category ? `slideshow-${category}` : ""}`}>
      <button onClick={prevSlide} className="slideshow-button">
        &#10094;
      </button>
      <div className="slideshow-image-container">
        <img
          src={images[currentIndex]}
          alt={`Slide ${currentIndex + 1}`}
          className={`slideshow-image ${currentImageStatus.loaded ? 'loaded' : ''}`}
        />
      </div>
      <button onClick={nextSlide} className="slideshow-button">
        &#10095;
      </button>
    </div>
  );
};

export default Slideshow;
